/** @format */

export interface SecondaryRatingsAverages {
  AverageRating: number;
  DisplayType: string;
  Id: string;
  Label: string;
  MaxLabel: string;
  MinLabel: string;
  ValueLabel?: string[];
  ValueRange: number;
}
